var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "position"
  }, [_c('main', {
    staticClass: "flex w-full h-full gap-[20px] bg-[#fff] p-4 rounded-[8px]",
    staticStyle: {
      "box-shadow": "var(--shadow-card, 0 2px 8px rgba(0, 0, 0, 0.06))"
    }
  }, [_c('div', {
    staticClass: "cluster"
  }, [_c('PositionCluster', {
    ref: "positionClusterRef",
    on: {
      "onChange": _vm.onChange,
      "onSearch": _vm.onSearch
    }
  })], 1), _c('div', {
    staticClass: "position_content"
  }, [_c('PositionList', {
    attrs: {
      "position": _vm.position,
      "searchValue": _vm.searchValue
    },
    on: {
      "onAddPosition": _vm.onAddPosition
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };